import { inject } from '@angular/core';
import { CanDeactivateFn } from '@angular/router';
import { PredefinedPricingTiersFacade } from '../facades/predefined-pricing-tiers.facade';

export function predefinedPricingTiersCleanup<T>(): CanDeactivateFn<T> {
    return () => {
        const predefinedPricingTiersFacade = inject(PredefinedPricingTiersFacade);
        predefinedPricingTiersFacade.clear();

        return true;
    };
}
